// React
import { useState } from 'react';

// External libraries
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/sharp-solid-svg-icons";

// Internal
import { getDataTestId } from "../functions/data-test-ids";
import { MultiValueInputTypes } from "../multi-value-type-input/multi-value-type-input";

// CSS
import "./tag-control.css";

function Tag(props) {
    const removeTag = () => {
        props.RemoveTag(props.Tag);
    }

    return (
        <div
            className={`eone-ui-tag-item ${props.IsCurrentInput ? " eone-ui-tag-item-outlined" : ""}`}
            data-testid={props.DataTestId}
        >
            <div className="eone-ui-tag-text" title={props.Tag}>
                {props.Tag}
            </div>
            <button
                className="eone-ui-tag-item-close"
                onClick={removeTag}
                data-testid={props.DataTestId ? getDataTestId(props.DataTestId, "remove") : undefined}
                aria-label={`Remove ${props.Tag}`}
            >
                <FontAwesomeIcon icon={faX} size={"2xs"} />
            </button>
        </div>
    );
}

function TagControl(props) {
    const [input, setInput] = useState('');

    const isValueEmpty = (value) => {
        //sort of a hack. restrictions get created with a single empty value that shows as a single empty tag that you cannot edit.
        //in this case just ignore that tag and have it be overwritten when they edit/add a new tag (no one will know the difference)
        return value === null || value === undefined || value === "";
    }

    const addTag = () => {
        if (input && !props.Value.includes(input)) {
            const values = props.Value.slice().filter(value => !isValueEmpty(value));
            values.push(input);
            props.OnChange(values);
            props.OnUpdate(values);
            setInput("");
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            addTag();
            e.preventDefault();
        }
    };

    const removeTag = (tagToRemove) => {
        const values = props.Value.filter(value => value !== tagToRemove);
        props.OnChange(values);
        props.OnUpdate(values);
    };

    const getTags = () => {
        return props.Value.filter(value => !isValueEmpty(value)).map((value, index) => {
            return (
                <Tag
                    key={index}
                    IsCurrentInput={value.Value === input}
                    Tag={value}
                    RemoveTag={removeTag}
                    DataTestId={props.DataTestId ? getDataTestId(props.DataTestId, "tag", value) : undefined} />
            );
        });
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <div className="eone-ui-tags-input-container" data-testid={props.DataTestId}>
            {getTags()}
            <input
                readOnly={props.ReadOnly}
                className="eone-ui-tags-input"
                type={props.ValueType === MultiValueInputTypes.Numbers ? "number" : "text"}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyPress}
                onBlur={addTag}
                placeholder=""
                data-testid={props.DataTestId ? getDataTestId(props.DataTestId, "input") : undefined} />
        </div>
    );
}

export { TagControl };
